import React from 'react';
import { connect } from 'react-redux';
import { useLocale } from 'locale';
import { ReportListingWrapper } from 'components/unit-page/report-listing/styled';
import { Text } from 'ds/components/typography';
import ReportIcon from 'assets/svg/report.svg';
import { setReportListingPopupOpen } from 'store/state/app/actions';
import withEvents from 'analytics/withEvents';


interface ReportListingProps {
  openReportListingPopup: () => void;
}

const ReportListing: React.FC<ReportListingProps> = props => {
  const { openReportListingPopup } = props;
  const { t } = useLocale();

  return (
    <ReportListingWrapper onClick={openReportListingPopup}>
      <ReportIcon />
      <Text data-auto="report-listing">{t('reportListing.text')}</Text>
    </ReportListingWrapper>
  );
};

const mapDispatchToProps = {
  openReportListingPopup: () => setReportListingPopupOpen(true),
};

export default connect(null, mapDispatchToProps)(withEvents(sendEvent => ({
  openReportListingPopup() {
    sendEvent('property_mistake_click', 'property');
  },
}))(ReportListing));
